/**
 * About page translations for 13 languages.
 * Content is identical in meaning across languages; wording adapted for cultural clarity.
 * Language codes: en, ar, ur, zh, fa, tr, fr, es, id, pt, de, it, bn
 */

const ABOUT_STRINGS = {
  ar: {
    backToHome: '← العودة إلى فلك',
    pageTitle: 'عن فلك',
    intro: '"فلك" تطبيق فلكي دقيق يضع بين يديك خدمات مبنيّة على حسابات علمية موثوقة، ترافقك في يومياتك المتّصلة بالتقويم القمري، والصلاة، والاتجاهات.',
    services: [
      {
        title: 'ولادة الهلال بدقّة الثانية',
        body: 'عدّاد تنازلي يُظهر الوقت المتبقّي لولادة هلال الشهر القادم — بالأيام والساعات والدقائق والثواني — مع بيان مدى سهولة رؤيته بعد ولادته وفق الظروف الفلكية.',
      },
      {
        title: 'موقفنا من الرؤية الشرعية',
        body: 'الحسابات الفلكية التي يقدّمها "فلك" ليست بديلاً عن الوسائل المعتمدة لإثبات دخول الشهر القمري، وهي: الرؤية بالعين المجرّدة، واستخدام الأجهزة الفلكية (البسيطة والمتطوّرة). "فلك" يحترم اختيار المستخدم لأيٍّ من هذه الوسائل وفق قناعته الشخصية.',
      },
      {
        title: 'تقاويم قمرية ممتدّة',
        body: 'تتيح دقّة الحسابات إعداد تقاويم قمرية موثوقة لسنوات وعقود قادمة، بدقّة تُضاهي التقاويم الشمسية.',
      },
      {
        title: 'مواقيت الصلاة',
        body: 'تُحسب بدقّة اعتماداً على موقع الشمس على مدار اليوم، وفق منهجيات أبرز المؤسسات المعتمدة — مع حرية اختيار طريقة الحساب.',
      },
      {
        title: 'جسر إلى الإيقاع الضوئي للطبيعة',
        body: 'قد تُلزم طبيعةُ العمل بعضَ المستخدمين بالبقاء في بيئات مغلقة أو ضمن مناوبات ليلية طويلة، بمعزلٍ عن حركة الضوء الطبيعي حولهم. تعمل واجهة "فلك" في هذه الحال كنافذة بصرية تُحاكي الحالة الضوئية الفعلية لموقعك الجغرافي — إذ تتبدّل ألوان الخلفية تلقائياً مع شروق الشمس وميلانها وغروبها، لتُبقيك متّصلاً بالإيقاع اليومي للضوء ولو من خلف الجدران.',
      },
      {
        title: 'تحديد الموقع تلقائياً',
        body: 'جميع الحسابات تعتمد على موقعك الجغرافي المرصود آلياً، دون أي إدخال يدوي.',
      },
      {
        title: 'اتجاه القبلة',
        body: 'بوصلة دقيقة تُرشدك إلى الكعبة المشرّفة من موقعك الحالي.',
      },
      {
        title: 'تقويم مزدوج',
        body: 'عرض متزامن للتقويمين الشمسي (الميلادي) والقمري (الهجري) بدقّة فلكية.',
      },
      {
        title: 'تأكيد أداء الصلاة',
        body: 'خاصية تفاعلية دقيقة تُتيح لك تأكيد أدائك للصلاة بضغطة واحدة على مستطيل الصلاة نفسه، فيتحوّل إلى لون أخضر شفاف يمنحك الطمأنينة البصرية. وضعنا قيوداً ذكية لضمان مصداقية هذه الخاصية: المستطيل لا يستجيب للضغط قبل دخول وقت الصلاة، ولا يمكن التراجع عن التأكيد لحسم الشكّ نهائياً، وتُمحى جميع التأكيدات تلقائياً منتصف الليل لتبدأ دورة نظيفة مع فجر اليوم التالي. صُمّمت لتكون رفيقاً موثوقاً لكبار السن ولمن يمرّون بلحظات السهو.',
      },
      {
        title: '"تمام الصلاة" — عدّاد ركعات مبتكر',
        body: 'بطاقة فريدة تُعينك على تتبّع عدد الركعات المؤدّاة دون تشتيت الخشوع. بعد السجود الأخير من كل ركعة، تلمس الشاشة برفق فتظهر دائرة صغيرة تُشير إلى الركعة المكتملة — بشدّة إضاءة قابلة للتخصيص لتُناسب الصلاة نهاراً أو ليلاً. ميزة استثنائيّة تُريحك من الشكّ في عدد الركعات، مصمَّمة بعناية لتحترم قدسيّة الصلاة.',
      },
      {
        title: 'التنبيهات الصوتية',
        body: 'أضف لمسة شخصية لتذكير نفسك بأوقات الصلاة عبر نغمة صوتية تختارها من هاتفك، مع التحكّم الكامل بمستوى الصوت وعدد مرات التكرار. تعمل النغمة حين يكون التطبيق مفتوحاً، ويمكنك أيضاً تفعيل إشعار عند دخول وقت كل صلاة والتطبيق مغلق، بصوت إشعارات هاتفك.',
      },
    ],
    closingTitle: 'كلمة أخيرة',
    closingBody: '"فلك" أُعدّ ليكون رفيقاً موثوقاً في يومك — ونأمل صادقين أن يُفيدك استخدامه وفق ما صُمِّم لأجله.',
    signature: 'مع خالص التقدير — فريق "فلك"',
  },

  en: {
    backToHome: '← Back to Falak',
    pageTitle: 'About Falak',
    intro: '"Falak" is a precision astronomical companion that puts a suite of scientifically grounded services at your fingertips — for the lunar calendar, prayer times, and directional guidance throughout your day.',
    services: [
      {
        title: 'New Moon Birth — Down to the Second',
        body: 'A live countdown showing the exact time remaining until the next lunar month begins — in days, hours, minutes and seconds — along with an indication of how easy the crescent will be to sight afterwards, based on prevailing astronomical conditions.',
      },
      {
        title: 'On Traditional Moon Sighting',
        body: 'The astronomical calculations offered by Falak are not a substitute for the recognized methods of confirming the start of a lunar month, namely: naked-eye observation, and observation using astronomical instruments (simple or advanced). Falak respects each user\'s freedom to rely on whichever method aligns with their personal conviction.',
      },
      {
        title: 'Extended Lunar Calendars',
        body: 'The precision of our calculations enables reliable lunar calendars for years and decades to come — at an accuracy comparable to established solar calendars.',
      },
      {
        title: 'Prayer Times',
        body: 'Computed precisely from the sun\'s position throughout the day, following the methodologies of major recognized institutions — with full freedom to select your preferred calculation method.',
      },
      {
        title: 'A Bridge to Nature\'s Light Rhythm',
        body: 'Some users\' work confines them to enclosed environments or long night shifts, isolated from the natural movement of light around them. In such cases, Falak\'s interface acts as a visual window that mirrors the actual light conditions at your geographic location — background colors shift automatically with sunrise, the sun\'s arc, and sunset, keeping you connected to the daily rhythm of light even from behind walls.',
      },
      {
        title: 'Automatic Location',
        body: 'All calculations rely on your automatically detected geographic position — no manual entry required.',
      },
      {
        title: 'Qibla Direction',
        body: 'A precise compass guiding you to the Holy Kaaba from your current location.',
      },
      {
        title: 'Dual Calendar',
        body: 'A synchronized view of the Gregorian (solar) and Hijri (lunar) calendars, based on astronomical accuracy.',
      },
      {
        title: 'Prayer Performance Confirmation',
        body: 'A precise, interactive feature that lets you confirm each prayer with a single tap on the prayer\'s own tile — turning it a soft transparent green that gives you visual peace of mind. We built in careful safeguards to preserve its integrity: the tile does not respond before the prayer\'s time has entered, confirmations cannot be undone (settling doubt for good), and all five marks clear automatically at midnight so a fresh cycle begins with the next Fajr. It is designed to be a trusted daily companion for the elderly, for those who occasionally forget, and for anyone who wishes to keep track of their prayers with absolute certainty.',
      },
      {
        title: '"Tamam al-Salah" — Innovative Rakat Counter',
        body: 'A unique feature that helps you track the rakats you have performed without breaking your focus in prayer. After the final prostration of each rakat, a gentle tap on the screen reveals a small circle marking the completed rakat — with adjustable brightness for day or night prayers. An exceptional companion that removes doubt about the rakat count, carefully designed to respect the sanctity of prayer.',
      },
      {
        title: 'Audio Notifications',
        body: 'Add a personal touch to your prayer-time reminders with a tone you choose from your phone — with full control over volume and repeat count. The tone plays while the app is open, and you can also turn on a notification at each prayer time even when the app is closed, using your phone\'s notification sound.',
      },
    ],
    closingTitle: 'A Closing Word',
    closingBody: '"Falak" is designed to be a trusted companion in your day — and we sincerely hope it serves you well, in the spirit for which it was created.',
    signature: 'With deepest respect — The Falak Team',
  },

  ur: {
    backToHome: '← فلک پر واپس جائیں',
    pageTitle: 'فلک کے بارے میں',
    intro: '"فلک" ایک درست فلکیاتی ایپلیکیشن ہے جو آپ کو سائنسی حسابات پر مبنی خدمات فراہم کرتی ہے — قمری تقویم، اوقاتِ نماز، اور سمت کی رہنمائی کے لیے۔',
    services: [
      {
        title: 'نئے چاند کی پیدائش — سیکنڈ کی درستگی کے ساتھ',
        body: 'ایک الٹی گنتی جو اگلے قمری مہینے کے آغاز تک باقی وقت کو دنوں، گھنٹوں، منٹوں اور سیکنڈوں میں دکھاتی ہے — اور ساتھ ہی موجودہ فلکیاتی حالات کے مطابق چاند کی رؤیت کی آسانی بھی بتاتی ہے۔',
      },
      {
        title: 'شرعی رؤیتِ ہلال پر ہمارا موقف',
        body: '"فلک" کے فلکیاتی حسابات قمری مہینے کے آغاز کی تصدیق کے تسلیم شدہ طریقوں کا متبادل نہیں ہیں، یعنی: عینِ خالص سے مشاہدہ، اور فلکیاتی آلات (سادہ یا جدید) کے ذریعے مشاہدہ۔ "فلک" ہر صارف کی آزادی کا احترام کرتا ہے کہ وہ اپنی ذاتی قناعت کے مطابق کوئی بھی طریقہ اختیار کرے۔',
      },
      {
        title: 'طویل قمری تقاویم',
        body: 'حسابات کی درستگی سالوں اور دہائیوں کے لیے قابلِ اعتماد قمری تقاویم فراہم کرتی ہے — شمسی تقاویم کے مساوی درستگی کے ساتھ۔',
      },
      {
        title: 'اوقاتِ نماز',
        body: 'دن بھر سورج کی پوزیشن کی بنیاد پر درست حساب سے، معتبر عالمی اداروں کے طریقوں کے مطابق — اور آپ کو اپنا پسندیدہ طریقۂ حساب منتخب کرنے کی مکمل آزادی۔',
      },
      {
        title: 'قدرت کے آہنگِ روشنی سے ایک پل',
        body: 'کچھ صارفین کے کام کی نوعیت انہیں بند ماحول یا طویل رات کی شفٹوں میں محدود رکھتی ہے، ان کے ارد گرد قدرتی روشنی کی حرکت سے علیحدہ۔ ایسے میں "فلک" کا انٹرفیس ایک بصری کھڑکی کا کام کرتا ہے جو آپ کے جغرافیائی مقام کی حقیقی روشنی کی صورتِ حال کی عکاسی کرتا ہے — پس منظر کے رنگ سورج کے طلوع، اس کے مدار اور غروب کے ساتھ خودکار طور پر بدلتے ہیں، تاکہ آپ دیواروں کے پیچھے سے بھی روزمرہ کی روشنی کے آہنگ سے جڑے رہیں۔',
      },
      {
        title: 'خودکار مقام کی تعیّن',
        body: 'تمام حسابات آپ کے خودکار طور پر شناخت کردہ جغرافیائی مقام پر مبنی ہیں — کوئی دستی اندراج ضروری نہیں۔',
      },
      {
        title: 'سمتِ قبلہ',
        body: 'ایک درست قطب نما جو آپ کے موجودہ مقام سے کعبۃ اللہ کی طرف رہنمائی کرتا ہے۔',
      },
      {
        title: 'دوہرا کیلنڈر',
        body: 'شمسی (میلادی) اور قمری (ہجری) تقاویم کا فلکیاتی درستگی کے ساتھ ہم آہنگ نظارہ۔',
      },
      {
        title: 'نماز کی ادائیگی کی تصدیق',
        body: 'ایک درست تعاملی خصوصیت جو آپ کو ایک ہی ٹیپ سے نماز کی ادائیگی کی تصدیق کرنے دیتی ہے — نماز کا خانہ ایک نرم شفاف سبز رنگ میں تبدیل ہو کر آپ کو بصری اطمینان دیتا ہے۔ ہم نے اس کی سچائی برقرار رکھنے کے لیے سمجھدارانہ حفاظتی تدابیر رکھی ہیں: نماز کا وقت داخل ہونے سے پہلے خانہ کام نہیں کرتا، تصدیق واپس نہیں لی جا سکتی (شک ہمیشہ کے لیے ختم)، اور تمام پانچ نشانات نصف رات کو خودکار طور پر مٹ جاتے ہیں تاکہ اگلی فجر کے ساتھ نیا دن شروع ہو۔ یہ بزرگوں، بھولنے والوں، اور ہر اُس شخص کے لیے قابلِ اعتماد روزانہ ساتھی کے طور پر ڈیزائن کی گئی ہے جو اپنی نمازوں کو مکمل یقین کے ساتھ ٹریک کرنا چاہتا ہے۔',
      },
      {
        title: '"تمام الصلاۃ" — اختراعی رکعات کاؤنٹر',
        body: 'ایک منفرد فیچر جو نماز کی توجہ کو متاثر کیے بغیر ادا کی گئی رکعتوں کو گننے میں مدد کرتا ہے۔ ہر رکعت کے آخری سجدے کے بعد اسکرین پر ہلکی سی چھونے سے ایک چھوٹا دائرہ ظاہر ہوتا ہے جو مکمل رکعت کی نشاندہی کرتا ہے — دن یا رات کی نماز کے لیے موافق روشنی کے ساتھ۔ ایک بے مثال ساتھی جو رکعتوں کی تعداد میں شک دور کرتا ہے، نماز کی حرمت کا مکمل احترام رکھتے ہوئے ڈیزائن کیا گیا ہے۔',
      },
      {
        title: 'آواز کی اطلاعات',
        body: 'اپنے فون سے منتخب کی گئی ایک ذاتی ٹون کے ذریعے نماز کے اوقات کی یاددہانی میں ایک شخصی لمس شامل کریں — آواز کی سطح اور تکرار کی تعداد پر مکمل کنٹرول کے ساتھ۔ ٹون ایپ کھلی ہونے پر چلتی ہے، اور آپ ایپ بند ہونے پر بھی ہر نماز کے وقت فون کی اطلاع والی آواز کے ساتھ اطلاع آن کر سکتے ہیں۔',
      },
    ],
    closingTitle: 'آخری بات',
    closingBody: '"فلک" آپ کے دن کا ایک قابلِ اعتماد ساتھی بننے کے لیے تیار کیا گیا ہے — اور ہمیں امید ہے کہ یہ اس مقصد کے مطابق آپ کی مدد کرے گا جس کے لیے یہ بنایا گیا ہے۔',
    signature: 'دلی احترام کے ساتھ — فلک ٹیم',
  },

  zh: {
    backToHome: '← 返回 Falak',
    pageTitle: '关于 Falak',
    intro: '"Falak"是一款精准的天文应用，为您提供基于科学计算的综合服务 — 陪伴您日常生活中与农历、礼拜时间和方向指引相关的需求。',
    services: [
      {
        title: '新月诞生 — 精确到秒',
        body: '实时倒计时显示下一个农历月开始的确切剩余时间 — 以天、小时、分钟和秒为单位 — 并根据当前天文条件说明月牙观测的难易程度。',
      },
      {
        title: '关于传统月相观测',
        body: 'Falak 提供的天文计算并非确认农历月开始的公认方法的替代品，即：肉眼观测和使用天文仪器（简易或高级）进行观测。Falak 尊重每位用户根据个人信念选择任何方法的自由。',
      },
      {
        title: '长期农历表',
        body: '计算的精度使我们能够为未来数年乃至数十年提供可靠的农历表 — 精度可与公认的公历表相媲美。',
      },
      {
        title: '礼拜时间',
        body: '基于全天太阳位置精确计算，遵循主要权威机构的方法 — 您可以自由选择偏好的计算方式。',
      },
      {
        title: '通往自然光节律的桥梁',
        body: '部分用户的工作性质使他们被困在封闭环境或长时间的夜班中，与周围自然光的运动隔绝。在这种情况下，Falak 的界面就像一扇视觉窗户，反映您所在地理位置的实际光照状况 —— 背景颜色会随着日出、太阳的运行轨迹和日落自动变化，让您即使身处四壁之内，也能与每日的光影节律保持联系。',
      },
      {
        title: '自动定位',
        body: '所有计算均基于自动检测的地理位置 — 无需手动输入。',
      },
      {
        title: '朝拜方向',
        body: '精准的指南针从您当前位置指向圣地天房。',
      },
      {
        title: '双历显示',
        body: '基于天文精度同步显示公历（阳历）和伊斯兰历（阴历）。',
      },
      {
        title: '礼拜完成确认',
        body: '一项精准的互动功能，让您通过点击礼拜自身的方块，即可确认您已完成礼拜 —— 方块会变为柔和的透明绿色，给予您视觉上的安心。为保障其真实性，我们精心设置了几道保障：方块在礼拜时间到达之前无法响应；确认后无法撤销（从此断绝疑虑）；每天午夜五个标记自动清除，等待次日晨礼开启新的一天。这项功能旨在成为长者、偶尔健忘者，以及所有希望以绝对确定的方式记录自己礼拜的人的可信赖日常伙伴。',
      },
      {
        title: '"完成礼拜" — 创新拜数计数器',
        body: '一项独特功能，帮助您追踪已完成的拜数而不打扰礼拜的专注。在每一拜的最后叩头后，轻触屏幕即可显示一个小圆点，标记已完成的一拜 — 亮度可调，适合白天或夜间礼拜。独特的伴侣，消除对拜数的疑虑，以尊重礼拜的神圣性为设计原则。',
      },
      {
        title: '声音提示',
        body: '为您的礼拜时间提醒添加一份个人色彩——从手机中选择心仪的铃声，自由调节音量和重复次数。铃声在应用打开时播放；您还可以开启通知，即使应用关闭，也会在每次礼拜时间以手机通知提示音提醒您。',
      },
    ],
    closingTitle: '结语',
    closingBody: '"Falak"旨在成为您日常生活中值得信赖的伙伴 — 我们衷心希望它能按照其设计初衷为您服务。',
    signature: '致以最深的敬意 — Falak 团队',
  },

  fa: {
    backToHome: '← بازگشت به فلک',
    pageTitle: 'درباره فلک',
    intro: '"فلک" یک برنامه نجومی دقیق است که مجموعه‌ای از خدمات مبتنی بر محاسبات علمی معتبر را در اختیار شما قرار می‌دهد — همراه شما در امور روزمره مرتبط با تقویم قمری، اوقات نماز و راهنمای جهت.',
    services: [
      {
        title: 'تولد هلال ماه — با دقت ثانیه',
        body: 'شمارش معکوس زنده‌ای که زمان دقیق باقی‌مانده تا آغاز ماه قمری بعدی را نشان می‌دهد — به روز، ساعت، دقیقه و ثانیه — همراه با نشانگر میزان آسانی رؤیت هلال بر اساس شرایط نجومی حاکم.',
      },
      {
        title: 'موضع ما در مورد رؤیت شرعی',
        body: 'محاسبات نجومی که فلک ارائه می‌دهد جایگزینی برای روش‌های شناخته‌شدهٔ تأیید آغاز ماه قمری نیست، یعنی: مشاهده با چشم غیرمسلح، و مشاهده با استفاده از ابزارهای نجومی (ساده یا پیشرفته). فلک آزادی هر کاربر را در انتخاب هر یک از این روش‌ها بر اساس اعتقاد شخصی محترم می‌شمارد.',
      },
      {
        title: 'تقاویم قمری بلندمدت',
        body: 'دقت محاسبات ما تهیه تقاویم قمری قابل اعتماد را برای سال‌ها و دهه‌های آینده امکان‌پذیر می‌سازد — با دقتی همتای تقاویم شمسی معتبر.',
      },
      {
        title: 'اوقات نماز',
        body: 'با دقت بر اساس موقعیت خورشید در طول روز محاسبه می‌شود، مطابق روش‌های نهادهای شناخته‌شدهٔ اصلی — با آزادی کامل در انتخاب روش محاسبه ترجیحی شما.',
      },
      {
        title: 'پلی به سوی آهنگ نور طبیعت',
        body: 'ماهیت کار برخی کاربران، آنان را در محیط‌های بسته یا شیفت‌های شبانهٔ طولانی محدود می‌کند و از حرکت طبیعی نور در اطرافشان جدا می‌سازد. در چنین شرایطی، رابط کاربری "فلک" همچون پنجره‌ای بصری عمل می‌کند که وضعیت واقعی نور در موقعیت جغرافیایی شما را بازتاب می‌دهد — رنگ‌های پس‌زمینه به‌طور خودکار با طلوع خورشید، مسیر حرکت آن و غروبش تغییر می‌کنند تا شما را حتی از پشت دیوارها با آهنگ روزانهٔ نور در ارتباط نگه دارند.',
      },
      {
        title: 'تعیین خودکار موقعیت',
        body: 'تمام محاسبات بر اساس موقعیت جغرافیایی شما که به صورت خودکار شناسایی می‌شود انجام می‌گیرد — بدون نیاز به ورود دستی.',
      },
      {
        title: 'جهت قبله',
        body: 'قطب‌نمای دقیقی که شما را از موقعیت فعلی به سمت کعبه معظمه راهنمایی می‌کند.',
      },
      {
        title: 'تقویم دوگانه',
        body: 'نمایش هم‌زمان تقویم‌های شمسی (میلادی) و قمری (هجری) با دقت نجومی.',
      },
      {
        title: 'تأیید ادای نماز',
        body: 'یک ویژگی تعاملی دقیق که به شما اجازه می‌دهد ادای هر نماز را با یک ضربه روی خانه‌ی همان نماز تأیید کنید — خانه به رنگ سبز شفاف ملایمی درمی‌آید که آرامش بصری به شما می‌دهد. برای حفظ اعتبار این ویژگی، ضمانت‌های دقیقی در نظر گرفته‌ایم: خانه پیش از آغاز وقت نماز پاسخ نمی‌دهد، تأیید قابل بازگشت نیست (شک برای همیشه از میان می‌رود)، و تمام پنج علامت در نیمه‌شب به‌طور خودکار پاک می‌شوند تا با فجر روز بعد چرخه‌ی تازه‌ای آغاز شود. این ویژگی به‌عنوان همراهی روزانه و قابل اعتماد برای سالمندان، برای کسانی که گاه فراموش می‌کنند و برای هر کسی که می‌خواهد نمازهایش را با اطمینان کامل پیگیری کند طراحی شده است.',
      },
      {
        title: '"تمام نماز" — شمارنده رکعات نوآورانه',
        body: 'یک ویژگی منحصر به فرد که به شما کمک می‌کند تعداد رکعات ادا شده را بدون از دست دادن خشوع دنبال کنید. پس از سجده آخر هر رکعت، لمس ملایم صفحه دایره‌ای کوچک را نمایان می‌کند که رکعت کامل شده را نشان می‌دهد — با روشنایی قابل تنظیم برای نمازهای روز یا شب. همراهی استثنایی که تردید در شمارش رکعات را از بین می‌برد، با احترام کامل به تقدس نماز طراحی شده است.',
      },
      {
        title: 'اعلان‌های صوتی',
        body: 'با انتخاب یک آهنگ از گوشی خود، به یادآوری اوقات نماز حس و حال شخصی ببخشید — با کنترل کامل بر میزان صدا و تعداد تکرار. آهنگ هنگام باز بودن برنامه پخش می‌شود؛ همچنین می‌توانید اعلانی را فعال کنید که حتی با بسته بودن برنامه، در آغاز وقت هر نماز با صدای اعلان گوشی شما را باخبر کند.',
      },
    ],
    closingTitle: 'سخن پایانی',
    closingBody: '"فلک" برای این طراحی شده که همراه قابل اعتماد شما در طول روز باشد — و ما صمیمانه امیدواریم که در راستای هدفی که برای آن ساخته شده است، به شما یاری رساند.',
    signature: 'با احترام عمیق — تیم فلک',
  },

  tr: {
    backToHome: '← Falak\'a Dön',
    pageTitle: 'Falak Hakkında',
    intro: '"Falak", bilimsel hesaplamalara dayalı bir dizi hizmeti parmaklarınızın ucuna getiren hassas bir astronomi uygulamasıdır — kameri takvim, namaz vakitleri ve yön rehberliği ile ilgili günlük yaşamınıza eşlik eder.',
    services: [
      {
        title: 'Yeni Ay\'ın Doğuşu — Saniye Hassasiyetinde',
        body: 'Bir sonraki kameri ayın başlamasına kalan tam süreyi gün, saat, dakika ve saniye cinsinden gösteren canlı bir geri sayım — ve mevcut astronomik koşullara göre hilalin ne kadar kolay gözlemlenebileceğinin bir göstergesi.',
      },
      {
        title: 'Şer\'i Hilal Rüyeti Konusundaki Tutumumuz',
        body: 'Falak\'ın sunduğu astronomik hesaplamalar, kameri ayın başlangıcının onaylanmasına yönelik kabul görmüş yöntemlerin yerine geçmez. Bu yöntemler şunlardır: çıplak gözle gözlem ve astronomik cihazlarla (basit veya gelişmiş) gözlem. Falak, her kullanıcının kişisel kanaatine uygun yöntemi seçme özgürlüğüne saygı duyar.',
      },
      {
        title: 'Uzun Vadeli Kameri Takvimler',
        body: 'Hesaplamalarımızın hassasiyeti, önümüzdeki yıllar ve on yıllar için güvenilir kameri takvimler oluşturmayı mümkün kılar — yerleşik güneş takvimlerine denk bir doğrulukla.',
      },
      {
        title: 'Namaz Vakitleri',
        body: 'Gün boyunca güneşin konumuna göre hassas biçimde hesaplanır ve başlıca tanınmış kuruluşların metodolojilerini takip eder — tercih ettiğiniz hesaplama yöntemini seçme özgürlüğüyle.',
      },
      {
        title: 'Doğanın Işık Ritmine Bir Köprü',
        body: 'Bazı kullanıcıların iş nitelikleri onları kapalı ortamlarda ya da uzun gece vardiyalarında, çevrelerindeki doğal ışık hareketinden yalıtılmış biçimde tutar. Böyle durumlarda Falak arayüzü, coğrafi konumunuzdaki gerçek ışık durumunu yansıtan görsel bir pencere işlevi görür — arka plan renkleri, gün doğumu, güneşin yörüngesi ve gün batımıyla otomatik olarak değişir; duvarların ardında olsanız bile günlük ışık ritmiyle bağlantınızı korumanızı sağlar.',
      },
      {
        title: 'Otomatik Konum Tespiti',
        body: 'Tüm hesaplamalar otomatik olarak algılanan coğrafi konumunuza dayanır — herhangi bir manuel giriş gerekmez.',
      },
      {
        title: 'Kıble Yönü',
        body: 'Mevcut konumunuzdan Kabe-i Muazzama\'ya yönlendiren hassas bir pusula.',
      },
      {
        title: 'Çift Takvim',
        body: 'Miladi (güneş) ve Hicri (kameri) takvimlerin astronomik hassasiyetle eşzamanlı görünümü.',
      },
      {
        title: 'Namaz Kılma Onayı',
        body: 'Namazınızın kendi kutucuğuna tek dokunuşla kıldığınızı onaylamanızı sağlayan hassas ve etkileşimli bir özellik — kutucuk yumuşak, şeffaf bir yeşile dönüşür ve size görsel bir iç huzuru verir. Bu özelliğin güvenilirliğini korumak için titiz güvenceler ekledik: kutucuk, namaz vakti girmeden yanıt vermez; onay geri alınamaz (şüphe böylece kesin olarak son bulur); ve gece yarısı beş işaret otomatik olarak silinir, böylece ertesi sabahın imsakıyla yeni bir döngü başlar. Yaşlılar için, ara sıra unutanlar için ve namazlarını mutlak kesinlikle takip etmek isteyen herkes için güvenilir bir günlük yoldaş olarak tasarlanmıştır.',
      },
      {
        title: '"Tamam al-Salah" — Yenilikçi Rekat Sayacı',
        body: 'Namazın huşusunu bozmadan kıldığınız rekatları takip etmenize yardımcı olan benzersiz bir özellik. Her rekatın son secdesinden sonra ekrana hafifçe dokunmak, tamamlanan rekatı işaretleyen küçük bir daire gösterir — gündüz veya gece namazlarına uygun ayarlanabilir parlaklıkla. Rekat sayısındaki şüpheyi ortadan kaldıran istisnai bir yoldaş, namazın kutsallığına saygıyla dikkatle tasarlandı.',
      },
      {
        title: 'Sesli Uyarılar',
        body: 'Namaz vakti hatırlatmalarına kişisel bir dokunuş katın — telefonunuzdan seçtiğiniz bir ton ile, ses seviyesi ve tekrar sayısı tam kontrolünüzde. Ton uygulama açıkken çalar; ayrıca uygulama kapalıyken bile her namaz vaktinde telefonun bildirim sesiyle uyarı almayı açabilirsiniz.',
      },
    ],
    closingTitle: 'Son Söz',
    closingBody: '"Falak", gününüzde güvenilir bir yoldaş olmak üzere tasarlanmıştır — ve içtenlikle umuyoruz ki yaratıldığı amaca uygun olarak size hizmet eder.',
    signature: 'En derin saygılarımızla — Falak Ekibi',
  },

  fr: {
    backToHome: '← Retour à Falak',
    pageTitle: 'À propos de Falak',
    intro: '"Falak" est une application astronomique de précision qui met à votre portée une suite de services rigoureusement scientifiques — pour vous accompagner au quotidien dans tout ce qui concerne le calendrier lunaire, les heures de prière et l\'orientation.',
    services: [
      {
        title: 'Naissance du Nouveau Croissant — à la Seconde Près',
        body: 'Un compte à rebours en direct affichant le temps exact restant avant le début du prochain mois lunaire — en jours, heures, minutes et secondes — ainsi qu\'une indication de la facilité de son observation selon les conditions astronomiques du moment.',
      },
      {
        title: 'Notre Position sur l\'Observation Traditionnelle',
        body: 'Les calculs astronomiques proposés par Falak ne se substituent pas aux méthodes reconnues pour confirmer le début d\'un mois lunaire, à savoir : l\'observation à l\'œil nu et l\'observation à l\'aide d\'instruments astronomiques (simples ou avancés). Falak respecte la liberté de chaque utilisateur de recourir à la méthode conforme à sa conviction personnelle.',
      },
      {
        title: 'Calendriers Lunaires Étendus',
        body: 'La précision de nos calculs permet d\'établir des calendriers lunaires fiables pour les années et décennies à venir — à une précision comparable à celle des calendriers solaires établis.',
      },
      {
        title: 'Heures de Prière',
        body: 'Calculées avec précision selon la position du soleil tout au long de la journée, en suivant les méthodologies des principales institutions reconnues — avec la liberté de choisir votre méthode de calcul préférée.',
      },
      {
        title: 'Un Pont vers le Rythme Lumineux de la Nature',
        body: 'La nature du travail de certains utilisateurs les confine dans des environnements clos ou de longues gardes de nuit, isolés du mouvement naturel de la lumière autour d\'eux. Dans ces situations, l\'interface de Falak agit comme une fenêtre visuelle reflétant les conditions lumineuses réelles de votre position géographique — les couleurs de l\'arrière-plan évoluent automatiquement avec le lever du soleil, sa course et son coucher, vous gardant en lien avec le rythme quotidien de la lumière, même derrière des murs.',
      },
      {
        title: 'Localisation Automatique',
        body: 'Tous les calculs reposent sur votre position géographique détectée automatiquement — aucune saisie manuelle requise.',
      },
      {
        title: 'Direction de la Qibla',
        body: 'Une boussole précise qui vous guide vers la Sainte Kaaba depuis votre position actuelle.',
      },
      {
        title: 'Calendrier Double',
        body: 'Une vue synchronisée des calendriers grégorien (solaire) et hégirien (lunaire), basée sur la précision astronomique.',
      },
      {
        title: 'Confirmation de l\'Accomplissement de la Prière',
        body: 'Une fonctionnalité interactive précise qui vous permet de confirmer chaque prière d\'une seule pression sur la tuile même de la prière — celle-ci prend alors une teinte verte translucide qui vous procure une tranquillité visuelle. Nous avons mis en place des garde-fous rigoureux pour préserver son intégrité : la tuile ne répond pas avant que l\'heure de la prière ne soit entrée, la confirmation ne peut pas être annulée (dissipant définitivement le doute), et les cinq marques s\'effacent automatiquement à minuit afin qu\'un nouveau cycle démarre avec le prochain Fajr. Elle a été conçue comme un compagnon quotidien fiable pour les personnes âgées, pour ceux qui oublient parfois, et pour quiconque souhaite suivre ses prières en toute certitude.',
      },
      {
        title: '"Tamam al-Salah" — Compteur de Rakats Innovant',
        body: 'Une fonctionnalité unique qui vous aide à suivre le nombre de rakats accomplis sans perturber votre khushu. Après la dernière prosternation de chaque rakat, un léger toucher de l\'écran fait apparaître un petit cercle marquant le rakat achevé — avec une luminosité ajustable pour les prières de jour ou de nuit. Un compagnon exceptionnel qui dissipe le doute sur le nombre de rakats, conçu avec respect pour la sacralité de la prière.',
      },
      {
        title: 'Notifications Sonores',
        body: 'Ajoutez une touche personnelle aux rappels des heures de prière grâce à un son que vous choisissez depuis votre téléphone — avec un contrôle total du volume et du nombre de répétitions. Le son est joué lorsque l\'application est ouverte, et vous pouvez aussi activer une notification à chaque heure de prière, même application fermée, avec le son de notification du téléphone.',
      },
    ],
    closingTitle: 'Un Mot pour Conclure',
    closingBody: '"Falak" a été conçu pour être un compagnon fiable dans votre journée — et nous espérons sincèrement qu\'il vous servira dans l\'esprit pour lequel il a été créé.',
    signature: 'Avec nos plus profonds respects — L\'équipe Falak',
  },

  bn: {
    backToHome: '← ফলকে ফিরে যান',
    pageTitle: 'ফলক সম্পর্কে',
    intro: '"ফলক" একটি নির্ভুল জ্যোতির্বৈজ্ঞানিক অ্যাপ যা বৈজ্ঞানিক গণনার ভিত্তিতে একগুচ্ছ সেবা আপনার হাতের মুঠোয় এনে দেয় — চান্দ্র বর্ষপঞ্জি, সালাতের সময় এবং দিকনির্দেশনার জন্য।',
    services: [
      {
        title: 'নতুন চাঁদের জন্ম — সেকেন্ডের নির্ভুলতায়',
        body: 'একটি লাইভ কাউন্টডাউন যা পরবর্তী চান্দ্র মাসের শুরু পর্যন্ত অবশিষ্ট সময় দেখায় — দিন, ঘণ্টা, মিনিট ও সেকেন্ডে — এবং বর্তমান জ্যোতির্বৈজ্ঞানিক অবস্থার ভিত্তিতে হেলাল দেখার সহজতার ইঙ্গিতসহ।',
      },
      {
        title: 'শরঈ চাঁদ দেখার বিষয়ে আমাদের অবস্থান',
        body: 'ফলক-এর দেওয়া জ্যোতির্বৈজ্ঞানিক গণনা চান্দ্র মাসের সূচনা নিশ্চিত করার স্বীকৃত পদ্ধতির বিকল্প নয়, যথা: খালি চোখে পর্যবেক্ষণ, এবং জ্যোতির্বৈজ্ঞানিক যন্ত্র (সরল বা উন্নত) ব্যবহার করে পর্যবেক্ষণ। ফলক প্রতিটি ব্যবহারকারীর ব্যক্তিগত বিশ্বাস অনুযায়ী যেকোনো পদ্ধতি বেছে নেওয়ার স্বাধীনতাকে সম্মান করে।',
      },
      {
        title: 'দীর্ঘমেয়াদী চান্দ্র বর্ষপঞ্জি',
        body: 'আমাদের গণনার নির্ভুলতা আগামী বছর ও দশকের জন্য নির্ভরযোগ্য চান্দ্র বর্ষপঞ্জি প্রস্তুতি সম্ভব করে — প্রতিষ্ঠিত সৌর বর্ষপঞ্জির সমতুল্য নির্ভুলতায়।',
      },
      {
        title: 'সালাতের সময়',
        body: 'সারাদিন সূর্যের অবস্থানের ভিত্তিতে নির্ভুলভাবে গণনা করা হয়, প্রধান স্বীকৃত প্রতিষ্ঠানগুলোর পদ্ধতি অনুসরণ করে — আপনার পছন্দের গণনা পদ্ধতি নির্বাচনের সম্পূর্ণ স্বাধীনতাসহ।',
      },
      {
        title: 'প্রকৃতির আলোর ছন্দে সেতুবন্ধ',
        body: 'কিছু ব্যবহারকারীর কাজের প্রকৃতি তাঁদের বদ্ধ পরিবেশ বা দীর্ঘ রাতের শিফটে সীমাবদ্ধ রাখে, চারপাশের প্রাকৃতিক আলোর গতি থেকে বিচ্ছিন্ন। এমন পরিস্থিতিতে, ফলক-এর ইন্টারফেস একটি দৃশ্যমান জানালার মতো কাজ করে যা আপনার ভৌগোলিক অবস্থানের প্রকৃত আলোক-অবস্থার প্রতিফলন ঘটায় — পটভূমির রঙ সূর্যোদয়, সূর্যের গতিপথ ও সূর্যাস্তের সঙ্গে স্বয়ংক্রিয়ভাবে পরিবর্তিত হয়, যাতে আপনি দেয়ালের ভেতর থেকেও দিনের আলোর ছন্দের সঙ্গে সংযুক্ত থাকেন।',
      },
      {
        title: 'স্বয়ংক্রিয় অবস্থান নির্ণয়',
        body: 'সমস্ত গণনা আপনার স্বয়ংক্রিয়ভাবে সনাক্তকৃত ভৌগোলিক অবস্থানের ওপর নির্ভর করে — কোনো ম্যানুয়াল ইনপুটের প্রয়োজন নেই।',
      },
      {
        title: 'কিবলার দিক',
        body: 'একটি নির্ভুল কম্পাস যা আপনার বর্তমান অবস্থান থেকে পবিত্র কাবার দিকে পথ প্রদর্শন করে।',
      },
      {
        title: 'দ্বৈত বর্ষপঞ্জি',
        body: 'গ্রেগরিয়ান (সৌর) ও হিজরি (চান্দ্র) বর্ষপঞ্জির সমন্বিত দৃশ্য, জ্যোতির্বৈজ্ঞানিক নির্ভুলতার ভিত্তিতে।',
      },
      {
        title: 'নামাজ আদায়ের নিশ্চিতকরণ',
        body: 'একটি সূক্ষ্ম ইন্টারঅ্যাক্টিভ বৈশিষ্ট্য যা আপনাকে নামাজের নিজস্ব ঘরে একটি ট্যাপ করেই নামাজ আদায় নিশ্চিত করতে দেয় — ঘরটি একটি নরম স্বচ্ছ সবুজ রঙে রূপান্তরিত হয়, যা আপনাকে দৃষ্টিগত প্রশান্তি দেয়। এই বৈশিষ্ট্যের নির্ভরযোগ্যতা রক্ষার জন্য আমরা যত্নসহকারে সুরক্ষা যুক্ত করেছি: নামাজের ওয়াক্ত শুরু হওয়ার আগে ঘরটি সাড়া দেয় না, নিশ্চিতকরণ পূর্বাবস্থায় ফেরানো যায় না (সন্দেহ চিরতরে দূর হয়), এবং মধ্যরাতে সব পাঁচটি চিহ্ন স্বয়ংক্রিয়ভাবে মুছে যায় যাতে পরবর্তী ফজরের সঙ্গে নতুন চক্র শুরু হয়। এটি বয়স্কদের জন্য, যাঁরা কখনো ভুলে যান তাঁদের জন্য, এবং যাঁরা সম্পূর্ণ নিশ্চিতভাবে তাঁদের নামাজ ট্র্যাক করতে চান তাঁদের জন্য একটি বিশ্বস্ত দৈনিক সঙ্গী হিসেবে ডিজাইন করা হয়েছে।',
      },
      {
        title: '"তামাম আস-সালাহ" — উদ্ভাবনী রাকাত কাউন্টার',
        body: 'একটি অনন্য বৈশিষ্ট্য যা নামাযের একাগ্রতা নষ্ট না করেই সম্পন্ন করা রাকাতের সংখ্যা ট্র্যাক করতে সাহায্য করে। প্রতিটি রাকাতের শেষ সিজদার পর স্ক্রীনে একটি হালকা স্পর্শ একটি ছোট বৃত্ত প্রকাশ করে যা সম্পূর্ণ রাকাতকে চিহ্নিত করে — দিন বা রাতের নামাযের জন্য সামঞ্জস্যযোগ্য উজ্জ্বলতা সহ। রাকাত গণনায় সন্দেহ দূর করার একটি ব্যতিক্রমী সঙ্গী, নামাযের পবিত্রতার প্রতি শ্রদ্ধা রেখে ডিজাইন করা।',
      },
      {
        title: 'অডিও বিজ্ঞপ্তি',
        body: 'আপনার ফোন থেকে বেছে নেওয়া একটি টোনের মাধ্যমে নামাজের সময়ের অনুস্মারকে একটি ব্যক্তিগত ছোঁয়া যোগ করুন — ভলিউম ও পুনরাবৃত্তির সংখ্যার উপর সম্পূর্ণ নিয়ন্ত্রণসহ। টোনটি অ্যাপ খোলা থাকলে বাজে; এছাড়া অ্যাপ বন্ধ থাকলেও প্রতিটি নামাজের সময় ফোনের বিজ্ঞপ্তির শব্দে সতর্কতা চালু করতে পারেন।',
      },
    ],
    closingTitle: 'সমাপনী বাক্য',
    closingBody: '"ফলক" আপনার দৈনন্দিন জীবনের নির্ভরযোগ্য সঙ্গী হিসেবে গড়ে তোলা হয়েছে — এবং আমরা আন্তরিকভাবে আশা করি এটি যে উদ্দেশ্যে তৈরি সেই অনুযায়ী আপনার সেবা করবে।',
    signature: 'গভীর শ্রদ্ধা সহকারে — ফলক টিম',
  },

  id: {
    backToHome: '← Kembali ke Falak',
    pageTitle: 'Tentang Falak',
    intro: '"Falak" adalah aplikasi astronomi presisi yang menyediakan serangkaian layanan berbasis perhitungan ilmiah — menemani Anda dalam keseharian yang berkaitan dengan kalender qamariah, waktu shalat, dan panduan arah.',
    services: [
      {
        title: 'Kelahiran Bulan Baru — Presisi Detik',
        body: 'Hitung mundur langsung yang menampilkan waktu tersisa hingga awal bulan qamariah berikutnya — dalam hari, jam, menit, dan detik — beserta indikasi kemudahan pengamatan hilal berdasarkan kondisi astronomi yang berlaku.',
      },
      {
        title: 'Sikap Kami terhadap Rukyat Syar\'i',
        body: 'Perhitungan astronomi yang ditawarkan Falak bukanlah pengganti metode yang diakui untuk memastikan awal bulan qamariah, yaitu: rukyat dengan mata telanjang, dan pengamatan menggunakan alat astronomi (sederhana maupun canggih). Falak menghormati kebebasan setiap pengguna untuk memilih metode sesuai keyakinan pribadinya.',
      },
      {
        title: 'Kalender Qamariah Jangka Panjang',
        body: 'Presisi perhitungan kami memungkinkan penyusunan kalender qamariah yang andal untuk bertahun-tahun dan puluhan tahun ke depan — dengan akurasi setara kalender syamsiah yang mapan.',
      },
      {
        title: 'Waktu Shalat',
        body: 'Dihitung secara presisi berdasarkan posisi matahari sepanjang hari, mengikuti metodologi institusi-institusi utama yang diakui — dengan kebebasan penuh memilih metode perhitungan pilihan Anda.',
      },
      {
        title: 'Jembatan menuju Irama Cahaya Alam',
        body: 'Sifat pekerjaan sebagian pengguna mengurung mereka dalam lingkungan tertutup atau shift malam yang panjang, terpisah dari pergerakan alami cahaya di sekitar mereka. Dalam situasi seperti ini, antarmuka Falak berperan sebagai jendela visual yang mencerminkan kondisi cahaya aktual di lokasi geografis Anda — warna latar berubah otomatis mengikuti terbit matahari, lintasannya, dan terbenamnya, sehingga Anda tetap terhubung dengan irama harian cahaya bahkan dari balik dinding.',
      },
      {
        title: 'Penentuan Lokasi Otomatis',
        body: 'Semua perhitungan mengandalkan lokasi geografis Anda yang terdeteksi otomatis — tanpa perlu input manual.',
      },
      {
        title: 'Arah Kiblat',
        body: 'Kompas presisi yang menuntun Anda ke Ka\'bah dari lokasi Anda saat ini.',
      },
      {
        title: 'Kalender Ganda',
        body: 'Tampilan sinkron kalender Masehi (syamsiah) dan Hijriah (qamariah) dengan akurasi astronomi.',
      },
      {
        title: 'Konfirmasi Pelaksanaan Shalat',
        body: 'Sebuah fitur interaktif presisi yang memungkinkan Anda mengonfirmasi setiap shalat cukup dengan satu ketukan pada kotak shalat itu sendiri — kotak akan berubah menjadi hijau transparan yang lembut, memberi Anda ketenangan visual. Kami menerapkan pengaman yang cermat untuk menjaga integritasnya: kotak tidak merespons sebelum waktu shalat masuk, konfirmasi tidak dapat dibatalkan (menghilangkan keraguan untuk selamanya), dan kelima tanda otomatis terhapus di tengah malam agar siklus baru dimulai dengan Subuh berikutnya. Fitur ini dirancang menjadi pendamping harian yang terpercaya bagi para lanjut usia, bagi mereka yang kadang lupa, dan bagi siapa pun yang ingin memantau shalatnya dengan kepastian penuh.',
      },
      {
        title: '"Tamam al-Salah" — Penghitung Rakaat Inovatif',
        body: 'Fitur unik yang membantu Anda melacak jumlah rakaat yang telah ditunaikan tanpa mengganggu kekhusyukan. Setelah sujud terakhir dari setiap rakaat, sentuhan lembut pada layar akan menampilkan lingkaran kecil sebagai tanda rakaat yang selesai — dengan kecerahan yang dapat disesuaikan untuk salat siang atau malam. Pendamping istimewa yang menghilangkan keraguan dalam menghitung rakaat, dirancang dengan penuh hormat terhadap kesucian salat.',
      },
      {
        title: 'Notifikasi Suara',
        body: 'Tambahkan sentuhan pribadi pada pengingat waktu salat Anda dengan nada yang Anda pilih dari ponsel — dengan kendali penuh atas volume dan jumlah pengulangan. Nada diputar saat aplikasi terbuka, dan Anda juga dapat mengaktifkan notifikasi di setiap waktu salat meski aplikasi tertutup, dengan suara notifikasi ponsel.',
      },
    ],
    closingTitle: 'Pesan Penutup',
    closingBody: '"Falak" dirancang untuk menjadi pendamping terpercaya di keseharian Anda — dan kami tulus berharap aplikasi ini bermanfaat bagi Anda sesuai dengan tujuan penciptaannya.',
    signature: 'Dengan hormat yang tulus — Tim Falak',
  },

  // ============================================================
  //  Español (es)
  // ============================================================
  es: {
    pageTitle: 'Acerca de Falak',
    intro: {
      p1: '"Falak" no es solo una aplicación para calcular horarios de oración o mostrar la fecha hégira — es un proyecto astronómico integrado, construido sobre principios científicos precisos y ecuaciones astronómicas rigurosas, calibradas para reflejar el estado real del cielo desde tu ubicación en el planeta, en el momento exacto en que abres la aplicación.',
      p2: 'Empezamos con una idea sencilla: acercar la belleza del cielo al bolsillo de cada usuario, con exactitud, sencillez y con una interfaz respetuosa hacia la experiencia religiosa e humana. Y a partir de ahí, todo comenzó a crecer.',
    },
    servicesTitle: 'Los servicios que ofrece Falak',
    services: [
      {
        title: 'Nacimiento del Creciente',
        body: 'Cálculo del momento del nacimiento astronómico del creciente para cada mes hégira, es decir, el momento exacto de la conjunción entre la Tierra, la Luna y el Sol — precisión al minuto y al segundo.',
      },
      {
        title: 'Distinción entre el nacimiento del creciente y su visibilidad',
        body: 'Los cálculos astronómicos que ofrece Falak no sustituyen los métodos aprobados para verificar el inicio del mes lunar, a saber: la observación a simple vista y la observación con instrumentos astronómicos (simples o avanzados). Falak respeta la libertad de cada usuario para elegir el método acorde a su convicción personal.',
      },
      {
        title: 'Calendario Hégira a Largo Plazo',
        body: 'La precisión de nuestros cálculos permite elaborar un calendario hégira fiable para años y décadas por venir — con la misma exactitud que un calendario solar establecido.',
      },
      {
        title: 'Horarios de Oración',
        body: 'Calculados con precisión a partir de la posición del sol a lo largo del día, siguiendo la metodología de las principales instituciones reconocidas — con plena libertad para elegir el método de cálculo que prefieras.',
      },
      {
        title: 'Un Puente hacia el Ritmo Natural de la Luz',
        body: 'La naturaleza del trabajo de algunos usuarios los mantiene encerrados en ambientes cerrados o en largos turnos de noche, alejados del movimiento natural de la luz. En estas situaciones, la interfaz de Falak actúa como una ventana visual que refleja la condición real de la luz en tu ubicación geográfica — los colores del fondo cambian automáticamente siguiendo el amanecer, su trayecto y su ocaso, para que sigas conectado al ritmo diario de la luz incluso desde detrás de una pared.',
      },
      {
        title: 'Detección Automática de Ubicación',
        body: 'Todos los cálculos se basan en tu ubicación geográfica detectada automáticamente — sin necesidad de entrada manual.',
      },
      {
        title: 'Dirección de la Qibla',
        body: 'Una brújula precisa que te guía hacia la Kaaba desde tu ubicación actual.',
      },
      {
        title: 'Calendario Doble',
        body: 'Una vista sincronizada del calendario gregoriano (solar) y del calendario hégira (lunar), basada en precisión astronómica.',
      },
      {
        title: 'Confirmación del Cumplimiento de la Oración',
        body: 'Una función interactiva y precisa que te permite confirmar cada oración con un solo toque sobre el mismo recuadro de la oración — el recuadro adopta un suave verde translúcido que te ofrece tranquilidad visual. Hemos incorporado salvaguardas cuidadosas para preservar su integridad: el recuadro no responde antes de que entre el horario de la oración, las confirmaciones no pueden deshacerse (disipando la duda para siempre), y las cinco marcas se borran automáticamente a medianoche para que un nuevo ciclo comience con el próximo Fajr. Está pensada para ser una compañera diaria fiable para las personas mayores, para quienes a veces se olvidan, y para todo aquel que desee seguir sus oraciones con absoluta certeza.',
      },
      {
        title: '"Tamam al-Salah" — Contador de Rakats Innovador',
        body: 'Una función única que te ayuda a contar los rakats realizados sin romper la concentración en la oración. Tras la última postración de cada rakat, un toque suave en la pantalla revela un pequeño círculo que marca el rakat completado — con brillo ajustable para oraciones diurnas o nocturnas. Un compañero excepcional que disipa la duda sobre el número de rakats, diseñado con respeto por la sacralidad de la oración.',
      },
      {
        title: 'Notificaciones de Audio',
        body: 'Añade un toque personal a los recordatorios de las horas de oración con un tono que eliges desde tu teléfono — con control total sobre el volumen y el número de repeticiones. El tono suena con la aplicación abierta, y también puedes activar una notificación en cada hora de oración aunque la aplicación esté cerrada, con el sonido de notificación del teléfono.',
      },
    ],
    closingTitle: 'Palabras finales',
    closingBody: '"Falak" ha sido diseñado para ser una compañía fiable en tu día a día — y sinceramente esperamos que la aplicación te resulte útil, tal como fue concebida.',
    signature: 'Con nuestro sincero respeto — El equipo de Falak',
  },

  // ============================================================
  //  Português (pt)
  // ============================================================
  pt: {
    pageTitle: 'Sobre o Falak',
    intro: {
      p1: '"Falak" não é apenas um aplicativo para calcular horários de oração ou exibir a data hégira — é um projeto astronômico integrado, construído sobre princípios científicos precisos e equações astronômicas rigorosas, calibradas para refletir o estado real do céu a partir da sua localização no planeta, no exato momento em que você abre o aplicativo.',
      p2: 'Começamos com uma ideia simples: aproximar a beleza do céu do bolso de cada usuário, com precisão, simplicidade e uma interface respeitosa da experiência religiosa e humana. E a partir daí, tudo começou a crescer.',
    },
    servicesTitle: 'Os serviços que o Falak oferece',
    services: [
      {
        title: 'Nascimento do Crescente',
        body: 'Cálculo do momento do nascimento astronômico do crescente para cada mês hégira, ou seja, o instante exato da conjunção entre a Terra, a Lua e o Sol — precisão ao minuto e ao segundo.',
      },
      {
        title: 'Distinção entre o nascimento do crescente e sua visibilidade',
        body: 'Os cálculos astronômicos oferecidos pelo Falak não substituem os métodos aprovados para confirmar o início do mês lunar, a saber: a observação a olho nu e a observação com instrumentos astronômicos (simples ou avançados). O Falak respeita a liberdade de cada usuário para escolher o método conforme sua convicção pessoal.',
      },
      {
        title: 'Calendário Hégira de Longo Prazo',
        body: 'A precisão de nossos cálculos permite compor um calendário hégira confiável para anos e décadas à frente — com a mesma exatidão de um calendário solar consolidado.',
      },
      {
        title: 'Horários de Oração',
        body: 'Calculados com precisão a partir da posição do sol ao longo do dia, seguindo a metodologia das principais instituições reconhecidas — com total liberdade para escolher o método de cálculo de sua preferência.',
      },
      {
        title: 'Uma Ponte para o Ritmo Natural da Luz',
        body: 'A natureza do trabalho de alguns usuários os mantém confinados em ambientes fechados ou em longos turnos noturnos, distantes do movimento natural da luz. Nessas situações, a interface do Falak atua como uma janela visual que reflete a condição real da luz em sua localização geográfica — as cores do fundo mudam automaticamente acompanhando o nascer do sol, seu trajeto e o pôr do sol, para que você permaneça conectado ao ritmo diário da luz mesmo por trás de uma parede.',
      },
      {
        title: 'Detecção Automática de Localização',
        body: 'Todos os cálculos baseiam-se na sua localização geográfica detectada automaticamente — sem necessidade de entrada manual.',
      },
      {
        title: 'Direção da Qibla',
        body: 'Uma bússola precisa que o guia até a Caaba a partir da sua localização atual.',
      },
      {
        title: 'Calendário Duplo',
        body: 'Uma visão sincronizada do calendário gregoriano (solar) e do calendário hégira (lunar), baseada em precisão astronômica.',
      },
      {
        title: 'Confirmação do Cumprimento da Oração',
        body: 'Um recurso interativo e preciso que permite confirmar cada oração com um único toque sobre o próprio quadrado da oração — o quadrado assume um verde translúcido suave que lhe dá tranquilidade visual. Incorporamos salvaguardas cuidadosas para preservar sua integridade: o quadrado não responde antes que o horário da oração comece, as confirmações não podem ser desfeitas (dissipando a dúvida definitivamente), e as cinco marcas são apagadas automaticamente à meia-noite para que um novo ciclo comece com o próximo Fajr. Foi concebido para ser um companheiro diário confiável para os idosos, para quem às vezes se esquece e para qualquer pessoa que deseje acompanhar suas orações com absoluta certeza.',
      },
      {
        title: '"Tamam al-Salah" — Contador de Rakats Inovador',
        body: 'Um recurso único que ajuda a acompanhar os rakats realizados sem quebrar a concentração da oração. Após a última prostração de cada rakat, um toque suave na tela revela um pequeno círculo marcando o rakat concluído — com brilho ajustável para orações diurnas ou noturnas. Um companheiro excepcional que elimina a dúvida sobre o número de rakats, projetado com respeito pela sacralidade da oração.',
      },
      {
        title: 'Notificações de Áudio',
        body: 'Dê um toque pessoal aos lembretes das horas de oração com um tom que você escolhe do seu telefone — com controlo total sobre o volume e o número de repetições. O tom toca com a aplicação aberta, e também pode ativar uma notificação em cada hora de oração mesmo com a aplicação fechada, com o som de notificação do telefone.',
      },
    ],
    closingTitle: 'Palavras finais',
    closingBody: '"Falak" foi projetado para ser um companheiro confiável em seu dia a dia — e sinceramente esperamos que o aplicativo lhe seja útil, exatamente como foi concebido.',
    signature: 'Com nosso sincero respeito — Equipe Falak',
  },

  // ============================================================
  //  Deutsch (de)
  // ============================================================
  de: {
    pageTitle: 'Über Falak',
    intro: {
      p1: '„Falak" ist nicht nur eine App zur Berechnung von Gebetszeiten oder zur Anzeige des Hidschri-Datums — es ist ein umfassendes astronomisches Projekt, aufgebaut auf präzisen wissenschaftlichen Grundlagen und rigorosen astronomischen Gleichungen, kalibriert, um den tatsächlichen Zustand des Himmels von Ihrem Standort auf der Erde widerzuspiegeln, genau in dem Moment, in dem Sie die App öffnen.',
      p2: 'Wir begannen mit einer einfachen Idee: die Schönheit des Himmels in die Tasche jedes Nutzers zu bringen, mit Genauigkeit, Einfachheit und einer Oberfläche, die das religiöse und menschliche Erleben respektiert. Von dort aus begann alles zu wachsen.',
    },
    servicesTitle: 'Die Dienste, die Falak bietet',
    services: [
      {
        title: 'Geburt der Mondsichel',
        body: 'Berechnung des Zeitpunkts der astronomischen Geburt der Mondsichel für jeden Hidschri-Monat, das heißt der genaue Augenblick der Konjunktion zwischen Erde, Mond und Sonne — mit Präzision auf die Minute und Sekunde.',
      },
      {
        title: 'Unterscheidung zwischen Geburt und Sichtbarkeit der Mondsichel',
        body: 'Die von Falak angebotenen astronomischen Berechnungen ersetzen nicht die anerkannten Methoden zur Bestätigung des Beginns eines Mondmonats, nämlich: die Beobachtung mit bloßem Auge und die Beobachtung mit astronomischen Instrumenten (einfachen oder fortgeschrittenen). Falak respektiert die Freiheit jedes Nutzers, die Methode zu wählen, die seiner persönlichen Überzeugung entspricht.',
      },
      {
        title: 'Langfristiger Hidschri-Kalender',
        body: 'Die Präzision unserer Berechnungen ermöglicht es, einen zuverlässigen Hidschri-Kalender für Jahre und Jahrzehnte im Voraus zu erstellen — mit derselben Genauigkeit wie ein etablierter Solarkalender.',
      },
      {
        title: 'Gebetszeiten',
        body: 'Präzise berechnet auf Grundlage der Sonnenposition im Tagesverlauf, gemäß den Methoden der wichtigsten anerkannten Institutionen — mit voller Freiheit, die von Ihnen bevorzugte Berechnungsmethode auszuwählen.',
      },
      {
        title: 'Eine Brücke zum natürlichen Rhythmus des Lichts',
        body: 'Die Art der Arbeit hält manche Nutzer in geschlossenen Umgebungen oder langen Nachtschichten fest, fern von der natürlichen Bewegung des Lichts um sie herum. In solchen Fällen wirkt die Oberfläche von Falak wie ein visuelles Fenster, das den tatsächlichen Lichtzustand an Ihrem geografischen Standort widerspiegelt — die Hintergrundfarben wechseln automatisch mit Sonnenaufgang, dem Bogen der Sonne und Sonnenuntergang, damit Sie mit dem täglichen Rhythmus des Lichts verbunden bleiben, selbst hinter Mauern.',
      },
      {
        title: 'Automatische Standorterkennung',
        body: 'Alle Berechnungen basieren auf Ihrem automatisch erkannten geografischen Standort — ohne manuelle Eingabe erforderlich.',
      },
      {
        title: 'Qibla-Richtung',
        body: 'Ein präziser Kompass, der Sie von Ihrem aktuellen Standort zur ehrwürdigen Kaaba führt.',
      },
      {
        title: 'Dualer Kalender',
        body: 'Eine synchronisierte Ansicht des gregorianischen (Sonnen-) und des Hidschri-(Mond-)Kalenders, basierend auf astronomischer Präzision.',
      },
      {
        title: 'Bestätigung der Gebetsverrichtung',
        body: 'Eine präzise interaktive Funktion, mit der Sie jedes Gebet mit einem einzigen Tippen auf die entsprechende Gebetskachel bestätigen können — die Kachel färbt sich in einem sanften transparenten Grün, das Ihnen visuelle Beruhigung gibt. Wir haben sorgfältige Sicherungen eingebaut, um die Integrität zu wahren: Die Kachel reagiert nicht, bevor die Gebetszeit eingetreten ist, Bestätigungen können nicht rückgängig gemacht werden (was Zweifel endgültig beseitigt), und alle fünf Markierungen werden um Mitternacht automatisch gelöscht, sodass ein neuer Zyklus mit dem nächsten Fadschr beginnt. Sie ist als vertrauenswürdiger täglicher Begleiter für ältere Menschen konzipiert, für diejenigen, die gelegentlich vergessen, und für alle, die ihre Gebete mit absoluter Gewissheit nachverfolgen möchten.',
      },
      {
        title: '„Tamam al-Salah" — Innovativer Rakat-Zähler',
        body: 'Eine einzigartige Funktion, die Ihnen hilft, die verrichteten Rakats zu zählen, ohne Ihre Konzentration im Gebet zu unterbrechen. Nach der letzten Prostration jedes Rakats offenbart ein sanftes Tippen auf den Bildschirm einen kleinen Kreis, der den vollzogenen Rakat markiert — mit anpassbarer Helligkeit für Tages- oder Nachtgebete. Ein außergewöhnlicher Begleiter, der Zweifel über die Zahl der Rakats beseitigt, sorgfältig gestaltet, um die Heiligkeit des Gebets zu wahren.',
      },
      {
        title: 'Audio-Benachrichtigungen',
        body: 'Verleihe deinen Gebetszeit-Erinnerungen eine persönliche Note mit einem Klang, den du von deinem Telefon auswählst — mit voller Kontrolle über Lautstärke und Wiederholungsanzahl. Der Klang spielt bei geöffneter App; zusätzlich kannst du eine Benachrichtigung zu jeder Gebetszeit aktivieren – auch bei geschlossener App, mit dem Benachrichtigungston des Telefons.',
      },
    ],
    closingTitle: 'Schlusswort',
    closingBody: '„Falak" wurde entworfen, um ein vertrauenswürdiger Begleiter in Ihrem Alltag zu sein — und wir hoffen aufrichtig, dass die App Ihnen dient, ganz im Geist, in dem sie geschaffen wurde.',
    signature: 'Mit tiefstem Respekt — Das Falak-Team',
  },

  // ============================================================
  //  Italiano (it)
  // ============================================================
  it: {
    pageTitle: 'Informazioni su Falak',
    intro: {
      p1: '"Falak" non è solo un\'app per calcolare gli orari di preghiera o mostrare la data dell\'Egira — è un progetto astronomico integrato, costruito su principi scientifici rigorosi ed equazioni astronomiche precise, calibrate per riflettere lo stato reale del cielo dalla tua posizione sul pianeta, nel momento esatto in cui apri l\'applicazione.',
      p2: 'Siamo partiti da un\'idea semplice: portare la bellezza del cielo nella tasca di ogni utente, con precisione, semplicità e un\'interfaccia rispettosa dell\'esperienza religiosa e umana. Da lì, tutto ha iniziato a crescere.',
    },
    servicesTitle: 'I servizi che Falak offre',
    services: [
      {
        title: 'Nascita della Falce di Luna',
        body: 'Calcolo del momento della nascita astronomica della falce di luna per ogni mese dell\'Egira, ovvero l\'istante esatto della congiunzione tra Terra, Luna e Sole — con precisione al minuto e al secondo.',
      },
      {
        title: 'Distinzione tra nascita della falce e sua visibilità',
        body: 'I calcoli astronomici offerti da Falak non sostituiscono i metodi riconosciuti per confermare l\'inizio del mese lunare, ovvero: l\'osservazione a occhio nudo e l\'osservazione con strumenti astronomici (semplici o avanzati). Falak rispetta la libertà di ogni utente di scegliere il metodo che meglio si accorda con la propria convinzione personale.',
      },
      {
        title: 'Calendario dell\'Egira a Lungo Termine',
        body: 'La precisione dei nostri calcoli consente di comporre un calendario dell\'Egira affidabile per anni e decenni a venire — con la stessa accuratezza di un calendario solare consolidato.',
      },
      {
        title: 'Orari di Preghiera',
        body: 'Calcolati con precisione a partire dalla posizione del sole durante il giorno, seguendo le metodologie delle principali istituzioni riconosciute — con piena libertà di scegliere il metodo di calcolo preferito.',
      },
      {
        title: 'Un Ponte verso il Ritmo Naturale della Luce',
        body: 'La natura del lavoro di alcuni utenti li costringe in ambienti chiusi o lunghi turni notturni, lontani dal movimento naturale della luce. In tali situazioni, l\'interfaccia di Falak funge da finestra visiva che riflette la condizione reale della luce nella tua posizione geografica — i colori dello sfondo cambiano automaticamente seguendo l\'alba, l\'arco del sole e il tramonto, per mantenerti connesso al ritmo quotidiano della luce anche dietro un muro.',
      },
      {
        title: 'Rilevamento Automatico della Posizione',
        body: 'Tutti i calcoli si basano sulla tua posizione geografica rilevata automaticamente — senza necessità di inserimento manuale.',
      },
      {
        title: 'Direzione della Qibla',
        body: 'Una bussola precisa che ti guida verso la Kaaba dalla tua posizione attuale.',
      },
      {
        title: 'Calendario Duplice',
        body: 'Una vista sincronizzata del calendario gregoriano (solare) e del calendario dell\'Egira (lunare), basata sulla precisione astronomica.',
      },
      {
        title: 'Conferma dell\'Adempimento della Preghiera',
        body: 'Una funzione interattiva e precisa che ti permette di confermare ogni preghiera con un singolo tocco sul riquadro della preghiera stessa — il riquadro assume un morbido verde traslucido che ti offre serenità visiva. Abbiamo integrato salvaguardie attente per preservarne l\'integrità: il riquadro non risponde prima che l\'orario della preghiera sia entrato, le conferme non possono essere annullate (fugando definitivamente il dubbio), e tutti e cinque i segni si cancellano automaticamente a mezzanotte, così che un nuovo ciclo cominci con il prossimo Fajr. È pensata per essere una compagna quotidiana affidabile per gli anziani, per chi talvolta dimentica, e per chiunque desideri seguire le proprie preghiere con assoluta certezza.',
      },
      {
        title: '"Tamam al-Salah" — Contatore Innovativo di Rakat',
        body: 'Una funzione unica che ti aiuta a tenere il conto dei rakat compiuti senza interrompere la concentrazione della preghiera. Dopo l\'ultima prostrazione di ogni rakat, un tocco delicato sullo schermo rivela un piccolo cerchio che segna il rakat completato — con luminosità regolabile per preghiere diurne o notturne. Un compagno eccezionale che dissipa il dubbio sul numero dei rakat, progettato con rispetto per la sacralità della preghiera.',
      },
      {
        title: 'Notifiche Audio',
        body: 'Aggiungi un tocco personale ai promemoria degli orari di preghiera con un suono scelto dal tuo telefono — con pieno controllo su volume e numero di ripetizioni. Il suono viene riprodotto con l\'app aperta, e puoi anche attivare una notifica a ogni orario di preghiera anche ad app chiusa, con il suono di notifica del telefono.',
      },
    ],
    closingTitle: 'Parole conclusive',
    closingBody: '"Falak" è stato concepito per essere un compagno affidabile nella tua giornata — e speriamo sinceramente che l\'applicazione ti sia utile, nello spirito con cui è stata creata.',
    signature: 'Con il nostro più sincero rispetto — Il Team Falak',
  },
};

/**
 * Get About page strings for a given language.
 * Falls back to English if the language is not supported.
 */
export function getAboutStrings(lang) {
  return ABOUT_STRINGS[lang] || ABOUT_STRINGS.en;
}

export const ABOUT_LANGS = Object.keys(ABOUT_STRINGS);
